import { Link } from "@tanstack/react-router";
import { categories, locations } from "@/lib/data";

export function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-surface">
      <div className="container mx-auto grid gap-10 px-4 py-14 md:grid-cols-4">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/logo.png"
              alt="Letslistbusiness"
              className="h-56 w-auto object-contain"
            />
          </Link>
          <p className="mt-4 max-w-xs text-sm text-muted-foreground">
            The local business directory for people who actually live here. Real
            reviews, real businesses, no noise.
          </p>
        </div>

        <div>
          <h4 className="mb-3 font-display text-sm font-semibold uppercase tracking-wider">
            Top Categories
          </h4>
          <ul className="space-y-2 text-sm">
            {categories.slice(0, 6).map((c) => (
              <li key={c.slug}>
                <Link
                  to="/category/$slug"
                  params={{ slug: c.slug }}
                  className="text-muted-foreground hover:text-foreground"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-3 font-display text-sm font-semibold uppercase tracking-wider">
            Top Cities
          </h4>
          <ul className="space-y-2 text-sm">
            {locations.slice(0, 6).map((l) => (
              <li key={l.slug}>
                <Link
                  to="/location/$slug"
                  params={{ slug: l.slug }}
                  className="text-muted-foreground hover:text-foreground"
                >
                  {l.name}, {l.state}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-3 font-display text-sm font-semibold uppercase tracking-wider">
            Company
          </h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-muted-foreground hover:text-foreground">Home</Link></li>
            <li><Link to="/about" className="text-muted-foreground hover:text-foreground">About</Link></li>
            <li><Link to="/contact" className="text-muted-foreground hover:text-foreground">Contact</Link></li>
            <li><Link to="/blog" className="text-muted-foreground hover:text-foreground">Local Guides</Link></li>
            <li><Link to="/sitemap" className="text-muted-foreground hover:text-foreground">Sitemap</Link></li>
            <li><Link to="/privacy-policy" className="text-muted-foreground hover:text-foreground">Privacy</Link></li>
            <li><Link to="/terms" className="text-muted-foreground hover:text-foreground">Terms</Link></li>
            <li><Link to="/disclaimer" className="text-muted-foreground hover:text-foreground">Disclaimer</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="container mx-auto flex flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-muted-foreground md:flex-row">
          <p>© {new Date().getFullYear()} LetsListBusiness. Made for local communities.</p>
          <p>Discover the best of your city.</p>
        </div>
      </div>
    </footer>
  );
}
